<script>
    import { Router, Route, Link } from "svelte-navigator";
    import qs from "qs";
    import baseUrl from "../config/config";
    import { onMount } from "svelte";

    let showSearchResults = false;
    let showSearchLoading = false;
    let q;
    let searchResults = [];

    let showMobileSearch = false;
    let showMobileMenu = false;

    let beer = [];

    let wine = [];

    let liquor = [];

    let others = [];

    const toggleMobileSearch = () => {
        showMobileSearch = !showMobileSearch;
    };

    const toggleMobileMenu = () => {
        showMobileMenu = !showMobileMenu;
    };

    const handleSearch = () => {
        let query = {
            q: q,
        };
        // show loading

        if (q.length < 3) {
            showSearchResults = false;
        } else {
            showSearchResults = true;
            showSearchLoading = true;

            fetch(baseUrl + "search.php", {
                method: "POST",
                body: JSON.stringify(query),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    console.log(data);

                    searchResults = data;

                    showSearchLoading = false;
                })
                .catch((e) => {
                    console.log(e);
                    showSearchLoading = false;
                });
        }
    };

    const getCategories = () => {
        fetch(baseUrl + "get-sticky-categories.php")
            .then((res) => res.json())
            .then((data) => {
                // console.log(data);
                wine = data.wine;
                beer = data.beer;

                liquor = data.liquor;

                others = data.others;
            })
            .catch((e) => {
                console.log(e);
            });
    };

    onMount(() => {
        getCategories();
    });
</script>

<main>
    <div class="computer tablet only compMainGrid ui grid">
        <div class="re two wide column">
            <div class="stickyLogo">
                <img
                    src="/assets/images/logo_white_.png"
                    alt="logo"
                    width="80%"
                    height="auto"
                />
            </div>
        </div>

        <div class="one wide column" />
        <div class="nine wide column">
            <div class="compNavBar">
                <div class="compNav">
                    <Link to="/">
                        <div class="link">HOME</div>
                    </Link>
                </div>

                <div class="compNav">
                    <Link to="/store">
                        <div class="link">STORE</div>
                    </Link>
                </div>

                <div class="compNav">
                    <Link to="/store/category/wine">
                        <div class="link">WINE</div>
                    </Link>

                    <!-- scats -->
                    <div class="scatBar">
                        <div class="categories">
                            <div class="catHead">CATEGORIES</div>
                            <div class="catContent">
                                <div class="ui grid">
                                    <div class="six wide column">
                                        <div class="catCol">
                                            {#each wine as w}
                                                <Link to={"/store/category/" + w.slug}>
                                                    <div
                                                        class="catLink"
                                                        style="display: inline-block;width:40%"
                                                    >
                                                        {w.name}
                                                    </div>
                                                </Link>
                                            {/each}
                                        </div>
                                    </div>

                                    <div class="orang four wide column">
                                        <div class="catImage">
                                            <img
                                                src="/assets/images/wine.jpeg"
                                                alt="logo"
                                                width="70%"
                                                height="auto"
                                                style="margin: auto;"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- scats -->
                </div>

                <div class="compNav">
                    <Link to="/category/beer">
                        <div class="link">BEER</div>
                    </Link>

                    <!-- scats -->
                    <div class="scatBar">
                        <div class="categories">
                            <div class="catHead">CATEGORIES</div>
                            <div class="catContent">
                                <div class="ui grid">
                                    <div class="six wide column">
                                        <div class="catCol">
                                            {#each beer as w}
                                                <Link to={"/store/category/" + w.slug}>
                                                    <div
                                                        class="catLink"
                                                        style="display: inline-block;width:40%"
                                                    >
                                                        {w.name}
                                                    </div>
                                                </Link>
                                            {/each}
                                        </div>
                                    </div>

                                    <div class="orang four wide column">
                                        <div class="catImage">
                                            <img
                                                src="/assets/images/beer.jpeg"
                                                alt="logo"
                                                width="70%"
                                                height="auto"
                                                style="margin: auto;"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- scats -->
                </div>

                <div class="compNav">
                    <Link to="/store/category/liquor">
                        <div class="link">LIQUOR</div>
                    </Link>

                    <!-- scats -->
                    <div class="scatBar">
                        <div class="categories">
                            <div class="catHead">CATEGORIES</div>
                            <div class="catContent">
                                <div class="ui grid">
                                    <div class="six wide column">
                                        <div class="catCol">
                                            {#each liquor as l}
                                                <Link to={"/store/category/" + l.slug}>
                                                    <div
                                                        class="catLink"
                                                        style="display: inline-block;width:40%"
                                                    >
                                                        {l.name}
                                                    </div>
                                                </Link>
                                            {/each}
                                        </div>
                                    </div>

                                    <div class="orang four wide column">
                                        <div class="catImage">
                                            <img
                                                src="/assets/images/liquor.jpeg"
                                                alt="logo"
                                                width="70%"
                                                height="auto"
                                                style="margin: auto;"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- scats -->
                </div>

                <div class="compNav">
                    <Link to="/store/category/others">
                        <div class="link">OTHERS</div>
                    </Link>

                    <!-- scats -->
                    <div class="scatBar">
                        <div class="categories">
                            <div class="catHead">CATEGORIES</div>
                            <div class="catContent">
                                <div class="ui grid">
                                    <div class="six wide column">
                                        <div class="catCol">
                                            {#each others as o}
                                                <Link to={"/store/category/" + o.slug}>
                                                    <div
                                                        class="catLink"
                                                        style="display: inline-block;width:40%"
                                                    >
                                                        {o.name}
                                                    </div>
                                                </Link>
                                            {/each}
                                        </div>
                                    </div>

                                    <div class="orang four wide column" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- scats -->
                </div>
            </div>
        </div>

        <div class="gree four wide column">
            <div class="ui grid">
                <div class="twelve wide column">
                    <div class="">
                        <div class="ui search">
                            <div class="ui icon input" style="width: 100%;">
                                <input
                                    class="prompt"
                                    type="text"
                                    placeholder="Search products"
                                    bind:value={q}
                                    on:keyup={handleSearch}
                                />

                                {#if showSearchLoading}
                                    <i class="ui loading spinner icon" />
                                {:else}
                                    <i class="search icon" />
                                {/if}
                            </div>
                            {#if showSearchResults}
                                <div class="results">
                                    <div class="resultsTitle">Products</div>
                                    <div class="resultsContent">
                                        {#each searchResults as result}
                                            <Link to={"/store/"+result.link}>
                                                <div class="searchLink">
                                                    {result.name}
                                                </div>
                                            </Link>
                                        {/each}
                                    </div>
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>

                <div class="one wide column">
                    <div class="compNav">
                        <Link to="/store/cart">
                            <div class="link">
                                <i class="cart icon" />
                            </div>
                        </Link>
                    </div>
                </div>

                <div class="blu one wide column">
                    <div class="compNav">
                        <Link to="/store/account">
                            <div class="link">
                                <i class="user icon" />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mobile only mobMainGrid ui grid">
        <div class="purpl three wide column">
            <div class="mobileMenuTriger">
                <i on:click={toggleMobileMenu} class="bars icon" />
            </div>
        </div>
        <div class="re five wide column">
            <div class="mstickyLogo">
                <img
                    src="/assets/images/logo_white_.png"
                    alt="logo"
                    width="100%"
                    height="auto"
                />
            </div>
        </div>
        <div class="two wide column" />

        <div class="purpl three wide column">
            <Link to="/cart">
                <div class="mobileCartTriger">
                    <i class="shopping cart alternate icon" />
                </div>
            </Link>
        </div>

        <div class="purpl three wide column">
            <div class="mobileSearchTriger">
                <i on:click={toggleMobileSearch} class="search icon" />
            </div>
        </div>

        <!-- search -->
        {#if showMobileSearch}
            <div
                class="mobileSearchCol re sixteen wide column"
                style="margin-top: -1em;"
            >
                <div class="" style="padding-left: 1em;">
                    <div class="ui search">
                        <div class="ui icon input" style="width: 100%;">
                            <input
                                class="prompt"
                                type="text"
                                placeholder="Search products"
                                bind:value={q}
                                on:keyup={handleSearch}
                            />

                            {#if showSearchLoading}
                                <i class="ui loading spinner icon" />
                            {:else}
                                <i class="search icon" />
                            {/if}
                        </div>
                        {#if showSearchResults}
                            <div class="results">
                                <div class="resultsTitle">Products</div>
                                <div class="resultsContent">
                                    {#each searchResults as result}
                                        <Link to={result.link}>
                                            <div class="searchLink">
                                                {result.name}
                                            </div>
                                        </Link>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        {/if}
        <!-- search -->

        <!-- mobile menu -->
        {#if showMobileMenu}
            <div
                class="mobileMenuCol yello sixteen wide column"
                style="margin-top:-1em"
            >
                <div class="ui grid">
                    <div class="sixteen wide column">
                        <div class="mobNav">
                            <Link to="/">
                                <div class="link">
                                    <i class="home icon" /> Home
                                </div>
                            </Link>
                        </div>

                        <div class="mobNav">
                            <Link to="/store">
                                <div class="link">
                                    <i class="fas fa-store" />

                                    Store
                                </div>
                            </Link>
                        </div>

                        <div class="mobNav">
                            <Link to="/store/category/wine">
                                <div class="link">
                                    <i class="fas fa-wine-glass-alt" /> Wines
                                </div>
                            </Link>
                        </div>

                        <div class="mobNav">
                            <Link to="/store/category/beer">
                                <div class="link">
                                    <i class="fas fa-beer" />
                                    Beer
                                </div>
                            </Link>
                        </div>

                        <div class="mobNav">
                            <Link to="/store/category/liquor">
                                <div class="link">
                                    <i class="fas fa-glass-whiskey" /> Liquors
                                </div>
                            </Link>
                        </div>

                        <div class="mobNav">
                            <Link to="/store/category/others">
                                <div class="link">
                                    <i class="fas fa-glass-martini-alt" /> Others
                                </div>
                            </Link>
                        </div>

                        <div class="mobNav">
                            <Link to="/store/account/">
                                <div class="link">
                                    <i class="user icon" /> Account
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        {/if}
        <!-- mobile menu -->
    </div>
</main>

<style>
    main {
        text-align: left;
    }

    .mobMainGrid {
        position: fixed !important;
        background-color: rgb(255, 255, 255);
        top: -1em;
        left: 0;
        z-index: 100;
        border-bottom: 1px solid rgba(224, 224, 224, 0.849);
        height: 3.5em;
        width: 104% !important;
    }

    /*  */
    .mobileMenuTriger {
        font-size: 22px;
        text-align: right;
        margin-top: -0.3em;
    }

    .mobileCartTriger {
        font-size: 22px;
        text-align: right;
        margin-top: -0.3em;
        color: black;
    }

    .mobileSearchTriger {
        font-size: 22px;
        text-align: right;
        margin-top: -0.3em;
    }

    .mobileSearchCol {
        background: #fff;
        border-bottom: 1px solid rgba(224, 224, 224, 0.849);
    }

    .mobileMenuCol {
        background: #fff;
        border-bottom: 1px solid rgba(224, 224, 224, 0.849);
        border-top: 1px solid rgb(224, 224, 224, 0.993);
    }

    .mstickyLogo {
        margin-top: -0.5em;
    }

    .mobNav {
        padding-left: 1em;
        line-height: 42px;
        font-weight: 500;
    }
    .compMainGrid {
        position: fixed !important;
        background-color: #fff;
        top: 0;
        left: 0;
        z-index: 100;
        border-bottom: 1px solid rgba(224, 224, 224, 0.582);
        height: 6em;
        padding-left: 3em !important;
        padding-right: 3em !important;
    }

    .stickyLogo {
        padding-top: 0.5em;
    }

    .compNavBar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .compNav {
        padding-top: 1em;
        line-height: 42px;
        font-weight: 500;
    }

    .compNav:hover .scatBar {
        display: block;
    }

    .link {
        color: black;
        letter-spacing: 2px;
        font-size: 14px;
    }

    .prompt {
        width: 100% !important;
        background: rgb(233, 233, 233) !important;
        border-radius: 3px !important;
    }

    .results {
        display: block !important;
        max-height: 40em;
        background: orange;
        overflow: auto;
        width: 100% !important;
    }

    .resultsTitle {
        color: rgb(117, 117, 117);
        padding: 1em;
    }

    .resultsContent {
        padding-left: 1em;
        padding-bottom: 1em;
    }

    .searchLink {
        font-weight: 400;
        padding-top: 1em;
        color: rgb(29, 28, 28);
    }

    .scatBar {
        background: rgb(255, 255, 255);
        width: 100% !important;
        position: fixed;
        left: 0;
        border-top: 1px solid rgba(189, 189, 189, 0.61);
        border-bottom: 1px solid rgb(196, 196, 196);
        padding-bottom: 1em;
        padding-top: 1em;
        display: none;
    }

    .categories {
        max-width: 80em;
        margin: auto;
    }

    .catLink {
        font-size: 13px;
        font-weight: 100;
        line-height: 24px;
        color: rgb(107, 107, 107);
    }

    .catCol {
        border-right: 1px solid rgb(202, 200, 200);
    }

    @media only screen and (min-width: 768px) {
        .ui.search {
            padding-top: 1em;
        }
    }
</style>
